import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MessageService } from '@openng/optimus-ui/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { FrontendForm } from '../../netgen/FrontendForm';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendFieldError } from "../../netgen/FrontendFieldError";
import { BackendResponse } from "../../shared/backend-response.model";

@Component({
    selector: 'app-reset-password-link',
    templateUrl: './reset-password-link.component.html',
    styleUrl: './reset-password-link.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordLinkComponent extends ComponentView {

  message = inject(MessageService);

  neededParams: ObjectOfSimpleDataTypes = { token: "string" };
  token: string;

  form: FrontendForm;

  userName = null;
  running = false;
  done = false;
  errorMessage: string;

  async initParams(): Promise<boolean> {
    if (this.running || this.done) {
      return true;
    }
    try {
      this.userName = await RestEndpoint.main().query({ token: this.token }).run("api/app/auth/getResetPasswordLinkUser").getString();
    }
    catch (error: any) {
      this.errorMessage = BackendResponse.getMessageFromException(error) ?? "Der Link zum Zurücksetzen des Passworts ist ungültig";
    }
    this.form = new FrontendForm([
        new FrontendField("password", "Neues Passwort", FrontendFieldType.password, { 
            mandatory: true,
                }),
        new FrontendField("passwordRepeat", "Neues Passwort wiederholen", FrontendFieldType.password, { 
            mandatory: true,
                    validator: (field, item) => field.getValue() != item.getValue("password") ? [new FrontendFieldError(field.id, this.app.t("general.changePassword.newPasswordRepeat_error1"))] : []
        })
    ]);
    return true;
  }

  async send(): Promise<void> {
    if (this.running || this.done) {
      return;
    }
    let errors = this.form.validate();
    if (!Utils.isNoe(errors)) {
        this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: errors[0].message});
        return;
    }

    this.running = true;
    try {
      if ((await this.app.genericDataHandler(async () => RestEndpoint.main().post().body({ token: this.token, userName: this.userName, password: this.form.getValue("password") }).run("api/app/auth/resetPasswordViaToken").getString(), "Fehler", "dialog")).ok) {
        this.done = true;
        this.message.add({ severity: "success", summary: "Ihr Passwort wurde erfolgreich zurückgesetzt"});
        Utils.setTimerOnce(3000, async () => {
          await this.app.navigateTo(["/base", "login"]);
        });
      }
    }
    finally {
      this.running = false;
    }
  }

  async requestNewLink(): Promise<void> {
    await this.app.navigate(["/base", "resetpassword"]);
  }
}
